// @ts-nocheck
import action from 'utils/actionCreators';

export const REGISTER_USER_REQUEST =
  'Varicon/@src/app/Register/REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS =
  'Varicon/@src/app/Register/REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE =
  'Varicon/@src/app/Register/REGISTER_USER_FAILURE';

export const GET_PERMISSION_ROLE_REQUEST =
  'Varicon/@src/app/Register/GET_PERMISSION_ROLE_REQUEST';
export const GET_PERMISSION_ROLE_SUCCESS =
  'Varicon/@src/app/Register/GET_PERMISSION_ROLE_SUCCESS';
export const GET_PERMISSION_ROLE_FAILURE =
  'Varicon/@src/app/Register/GET_PERMISSION_ROLE_FAILURE';

export const registerUserRequest = action(REGISTER_USER_REQUEST, 'payload');
export const registerUserSuccess = action(REGISTER_USER_SUCCESS);
export const registerUserFailure = action(REGISTER_USER_FAILURE);

export const getPermissionRoleRequest = action(GET_PERMISSION_ROLE_REQUEST);
export const getPermissionRoleSuccess = action(GET_PERMISSION_ROLE_SUCCESS);
export const getPermissionRoleFailure = action(GET_PERMISSION_ROLE_FAILURE);
